import Replay from "../replay/Replay";

const SERVICE_IDENTIFIER = {
	Gameset: Symbol("Gameset"),
	MadnesAdapter: Symbol("MadnesAdapter"),
	Commander: Symbol("Commander"),
	InfoPages: Symbol("InfoPages"),
	ParagraphPage: Symbol("ParagraphPage"),

	Engine: Symbol("Engine"),
	EngineAppInit: Symbol("EngineAppInit"),
	EngineApp: Symbol("EngineApp"),
	EngineAudio: Symbol("EngineAudio"),
	EngineDebug: Symbol("EngineDebug"),
	EngineLoader: Symbol("Loader"),
	EngineAppLayers: Symbol("AppLayers"),
	EngineAppSymbols: Symbol("PixiSymbols"),

	FontPreloader: Symbol("FontPreloader"),
	LoadingScreen: Symbol("Loading"),

	Settings: Symbol("Settings"),
	Fullscreen: Symbol("Fullscreen"),
	InitWallet: Symbol("InitWallet"),
	Wallet: Symbol("Wallet"),
	Freespins: Symbol("Freespins"),
	System: Symbol("System"),
	SystemInit: Symbol("SystemInit"),
	StatesManager: Symbol("StatesManager"),
	BaseStates: Symbol("BaseStates"),
	SystemConfig: Symbol("SystemConfig"),
	SystemPlatform: Symbol("SystemPlatform"),
	SystemTime: Symbol("SystemTime"),
	SystemDebug: Symbol("SystemDebug"),
	ErrorHandler: Symbol("ErrorHandler"),
	PlayerOptions: Symbol("PlayerOptions"),

	SystemMessages: Symbol("SystemMessages"),

	ConnectFactory: Symbol("ConnectFactory"),
	Connect: Symbol("Connect"),
	ConnectControl: Symbol("ConnectControl"),
	ConnectControlRegulations: Symbol("ConnectControlRegulations"),
	ConnectSettings: Symbol("ConnectSettings"),
	ConnectInit: Symbol("ConnectInit"),
	ConnectAdd: Symbol("ConnectAdd"),
	ConnectEnd: Symbol("ConnectEnd"),
	ConnectClose: Symbol("ConnectClose"),
	ConnectBalance: Symbol("ConnectBalance"),
	ConnectRegulation: Symbol("ConnectRegulation"),
	ConnectReplay: Symbol("ConnectReplay"),
	ConnectLogic: Symbol("ConnectLogic"),
	// player settings
	ConnectGetDeviceOpt: Symbol("ConnectGetDeviceOpt"),
	ConnectSetDeviceOpt: Symbol("ConnectSetDeviceOpt"),
	ConnectGetGameOpt: Symbol("ConnectGetGameOpt"),
	ConnectSetGameOpt: Symbol("ConnectSetGameOpt"),
	ConnectGetLastOpts: Symbol("ConnectGetLastOpts"),
	ConnectGetButtonOpt: Symbol("ConnectGetButtonOpt"),
	ConnectSetButtonOpt: Symbol("ConnectSetButtonOpt"),

	ConnectWebsocket: Symbol("ConnectWebsocket"),
	ConnectGetSessions: Symbol("ConnectGetSessions"),
	ConnectGetGameSessions: Symbol("ConnectGetGameSessions"),
	ConnectPlatformSettings: Symbol("ConnectPlatformSettings"),

	FetchAjax: Symbol("FetchAjax"),
	// FetchAjaxTest: Symbol("FetchAjaxTest"),

	Regulation: Symbol("Regulation"),

	PostMessages: Symbol("PostMessages"),

	Game: Symbol("Game"),
	GameCore: Symbol("GameCore"),
	Replay: Symbol("Replay"),

	UI: Symbol("UI"),
	DOM: Symbol("DOM"),
	UIActions: Symbol("UIActions"),
	UIMessages: Symbol("UIMessages"),
	UIController: Symbol("UIController"),
	AudioController: Symbol("AudioController"),
	PauseOverlay: Symbol("PauseOverlay"),
	UIStates: Symbol("UIStates"),
	UIScreen: Symbol("UISymbol"),
	ButtonSounds: Symbol("ButtonSounds"),

	HwButtonsStates: Symbol("HwButtonsStates"),
	History: Symbol("History"),
};

export default SERVICE_IDENTIFIER;
